<div
    class="lg-dropdown-popup__wrapper"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    [attr.data-testid]="dataTestIdPrefix + '.popup'"
>
    @if (!_shownAbove) {
        <ng-container [ngTemplateOutlet]="searchInput"></ng-container>
    }

    @if (definition?.extraTop) {
        <div
            class="lg-dropdown-popup__extra lg-dropdown-popup__extra--top"
            [class.lg-dropdown-popup__extra--clickable]="
                definition.extraTop!.onClick || definition.extraTop!.url
            "
            [class.lg-dropdown-popup__extra--focused]="_currentEntryIndex === -2"
            (click)="_onExtraClick($event, definition.extraTop!)"
        >
            <lg-icon [icon]="definition.extraTop!.icon" [inline]="true"></lg-icon>
            {{ definition.extraTop!.name }}
        </div>
    }

    <div class="lg-dropdown-popup__main">
        <div id="__LG_DROPDOWN_RENDERED_ITEMS__" class="lg-dropdown-popup__entries">
            <div
                class="lg-dropdown-popup__entries lg-dropdown-popup__entries--first"
                id="__LG_DROPDOWN_GROUP__"
            >
                <div class="lg-dropdown-popup__entries__group">
                    <div class="lg-dropdown-popup__entries__group__name">G</div>
                </div>
            </div>
            <div class="lg-dropdown-popup__entries" id="__LG_DROPDOWN_ENTRY__">
                <div class="lg-dropdown-popup__entries__entry">
                    <span class="lg-dropdown-popup__entries__entry__name">E</span>
                </div>
            </div>
            <div
                class="lg-dropdown-popup__entries lg-dropdown-popup__entries--last"
                id="__LG_DROPDOWN_ENTRY--LAST__"
            >
                <div class="lg-dropdown-popup__entries__entry">
                    <span class="lg-dropdown-popup__entries__entry__name">E</span>
                </div>
            </div>
            <div
                class="lg-dropdown-popup__entries lg-dropdown-popup__entries--first"
                id="__LG_DROPDOWN_ENTRY--FIRST__"
            >
                <div class="lg-dropdown-popup__entries__entry">
                    <span class="lg-dropdown-popup__entries__entry__name">E</span>
                </div>
            </div>
            <div
                class="lg-dropdown-popup__entries lg-dropdown-popup__entries--first lg-dropdown-popup__entries--last"
                id="__LG_DROPDOWN_ENTRY--FIRST--LAST__"
            >
                <div class="lg-dropdown-popup__entries__entry">
                    <span class="lg-dropdown-popup__entries__entry__name">E</span>
                </div>
            </div>
        </div>
    </div>

    @if (_itemHeights) {
        <div
            class="lg-dropdown-popup__main"
            #contentHolder
            lgScrollable
            [lgDefaultFocus]="_hideSearch"
            [tabIndex]="0"
            lgScrollableAutoHide="true"
            lgScrollableWrapperClass="lg-dropdown-popup__scrollable"
            [attr.data-testid]="dataTestIdPrefix + '.scrollable'"
            #scroller
        >
            <div
                *lgVirtualFor="
                    let entry of _renderedEntries;
                    let first = first;
                    height: _getItemHeight;
                    ensureVisible: _visible$;
                    renderingBuffer: _renderingBuffer
                "
                class="lg-dropdown-popup__entries"
                [style.border-top-width.px]="first ? '0' : GROUP_SEPARATOR_HEIGHT"
                [class.lg-dropdown-popup__entries--first]="entry.isFirstEntryInGroup"
                [class.lg-dropdown-popup__entries--last]="entry.isLastEntryInGroup"
                [attr.data-testid]="dataTestIdPrefix + '.entries'"
            >
                @if (entry.isGroup) {
                    <div class="lg-dropdown-popup__entries__group">
                        @if (entry.name) {
                            <div
                                class="lg-dropdown-popup__entries__group__name"
                                [class.lg-dropdown-popup__entries__group__name--with-help]="
                                    entry.help
                                "
                            >
                                {{ entry.name }}
                            </div>
                        }
                        @if (entry.help) {
                            <lg-icon
                                [icon]="'icon-help'"
                                [inline]="true"
                                class="lg-dropdown-popup__entries__group-help"
                                [lgTooltip]="entry.help"
                                [lgTooltipOptions]="_tooltipOptions"
                            ></lg-icon>
                        }
                    </div>
                }
                @if (!entry.isGroup) {
                    <div
                        (click)="_onEntryClick(entry)"
                        class="lg-dropdown-popup__entries__entry"
                        [class.lg-dropdown-popup__entries__entry--focused]="
                            _cursorId === entry.id && _keyboardTouched
                        "
                        [class.lg-dropdown-popup__entries__entry--disabled]="entry.disabled"
                        [class.lg-dropdown-popup__entries__entry--selected]="
                            entry.id === _selectedCursorId && _highlightSelected
                        "
                    >
                        @if (entry.icon) {
                            <lg-icon
                                [icon]="entry.icon.icon"
                                [title]="entry.icon.title"
                                [inline]="true"
                                [clickable]="entry.icon.clickable"
                                class="lg-icon--inline {{ entry.icon.iconClass }}"
                                (click)="_onIconClick($event, entry)"
                            ></lg-icon>
                        }
                        <span
                            [title]="_itemTooltips ? entry.name : ''"
                            class="lg-dropdown-popup__entries__entry__name"
                            [class.lg-dropdown-popup__entries__entry__name--with-help]="entry.help"
                        >
                            @if (entry.highlightedName) {
                                <span [innerHtml]="entry.highlightedName"> </span>
                            }
                            @if (!entry.highlightedName) {
                                <span>
                                    {{ entry.name }}
                                </span>
                            }
                        </span>
                        @if (entry.help) {
                            <lg-icon
                                [inline]="true"
                                class="lg-dropdown-popup__entries__entry-help"
                                [icon]="'icon-help'"
                                [lgTooltip]="entry.help"
                                [lgTooltipOptions]="_tooltipOptions"
                            ></lg-icon>
                        }
                    </div>
                }
            </div>
        </div>
    }

    @if (definition?.extraBottom) {
        <div
            class="lg-dropdown-popup__extra lg-dropdown-popup__extra--bottom"
            [class.lg-dropdown-popup__extra--clickable]="
                definition.extraBottom!.onClick || definition.extraBottom!.url
            "
            [class.lg-dropdown-popup__extra--focused]="_currentEntryIndex === -3"
            (click)="_onExtraClick($event, definition.extraBottom!)"
        >
            <lg-icon [icon]="definition.extraBottom?.icon" [inline]="true"></lg-icon>
            {{ definition.extraBottom?.name }}
        </div>
    }

    @if (_shownAbove) {
        <ng-container [ngTemplateOutlet]="searchInput"></ng-container>
    }
</div>

<ng-template #searchInput>
    @if (!_hideSearch) {
        <input
            type="text"
            class="input input--no-highlight input--no-border input--no-shadow"
            [ngClass]="{ 'input--condensed': _isControlCondensed }"
            placeholder="{{ 'FW._Directives.lgDropdown_Search_placeholder' | lgTranslate }}"
            [ngModel]="_quickFilter"
            (ngModelChange)="_onQuickFilterChange($event)"
            (blur)="_onQuickFilterBlur($event)"
            lgDefaultFocus
        />
    }
</ng-template>
